import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const TAG_GLOSS: [string, string][] = [
  ["DEFINE", "a word a first time reader would not know"],
  ["CONFUSING", "you had to read it twice"],
  ["INSIDER", "tool names, status words, abbreviations"],
  ["CUTE", "jokes, winks, pep talk"],
  ["TONE", "fear, pressure, shame, or it made you feel worse"],
  ["MISSING", "a step, an answer, or a next action is not here"],
  ["VISUAL", "this wants a picture; say what it would show"],
  ["LONG", "it made its point and kept going"],
  ["ORDER", "a step assumes something not yet explained"],
  ["PROMISE", "a guarantee or always language; flag, never soften"],
  ["CONTRADICTS", "another page disagrees; give its id"],
  ["FACT", "a number, date, amount, or link looks wrong; flag, never edit"],
];

function Label({ children }: { children: React.ReactNode }) {
  return <div className="text-xs font-bold uppercase tracking-wide mt-4 mb-1">{children}</div>;
}

export function ReviewerWelcome({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Card className="p-5 border-l-4 border-l-primary bg-muted/30 relative">
      <button
        onClick={onDismiss}
        aria-label="Dismiss"
        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
      >
        <X className="h-4 w-4" />
      </button>
      <h2 className="text-lg font-serif font-semibold mb-2">Welcome, Robin</h2>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-3xl">
        You are reading every page as the newest member on their first day. The pause is the data.
        Flag first, fix after.
      </p>

      <Label>How the page works</Label>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-3xl">
        Left pane: read. Highlight any words and press Flag this, pick a tag, send. Right pane:
        rewrite anything that would read better; it autosaves, and Send rewrite sends it to the checker; clean edits publish on their own. Press Done with this page when you are finished; that marks it reviewed and takes it off your list.
      </p>

      <Label>What we are looking for</Label>
      <ul className="text-sm text-muted-foreground space-y-0.5 max-w-3xl">
        {TAG_GLOSS.map(([tag, gloss]) => (
          <li key={tag}>
            <span className="font-semibold text-foreground">{tag}</span>, {gloss}.
          </li>
        ))}
      </ul>

      <Label>What you may fix yourself</Label>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-3xl">
        Sentences, word choice, paragraph breaks, grammar, punctuation. Facts, links, and headings
        are locked on purpose.
      </p>

      <Label>Pace</Label>
      <p className="text-sm text-muted-foreground leading-relaxed max-w-3xl">
        Fifteen to twenty pages a day. Close the laptop mid sentence whenever you like; nothing is
        lost.
      </p>

      <div className="mt-4">
        <Button size="sm" variant="outline" onClick={onDismiss}>
          Got it
        </Button>
      </div>
    </Card>
  );
}
